import React from 'react';
import './AdminStats.scss';

const AdminStats = ({ newsCount, booksCount, authorsCount }) => {
  return (
    <div className="admin-stats">
      <div className="stat-card">
        <span className="stat-value">{newsCount}</span>
        <span className="stat-label">Новостей</span>
      </div>
      <div className="stat-card">
        <span className="stat-value">{booksCount}</span>
        <span className="stat-label">Книг</span>
      </div>
      <div className="stat-card">
        <span className="stat-value">{authorsCount}</span>
        <span className="stat-label">Авторов</span>
      </div>
    </div>
  );
};

export default AdminStats;
